function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M500,83.33C224.16,83.33,0,270.41,0,500A374.12,374.12,0,0,0,102.9,753.32L83.75,867.93A40.84,40.84,0,0,0,97.1,905.81,42.06,42.06,0,0,0,125,916.62a34.87,34.87,0,0,0,11.24-1.68l143.35-40.82A586.51,586.51,0,0,0,500,916.67c275.84,0,500-187.08,500-416.67S775.84,83.33,500,83.33Zm0,750a499.06,499.06,0,0,1-200.84-41.24,40.32,40.32,0,0,0-16.84-3.75A35.36,35.36,0,0,0,271.09,790l-94.15,26.69,11.65-70.41a41.6,41.6,0,0,0-11.82-36.7A292.16,292.16,0,0,1,83.33,500c0-183.75,187.08-333.33,416.67-333.33S916.67,316.25,916.67,500,729.59,833.33,500,833.33Z",
    style: {
      stroke: "#fff",
      strokeWidth: "0.699999988079071px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.67,438.76A95,95,0,0,0,268,442.09a88.73,88.73,0,0,0-10.81,5.85,60.64,60.64,0,0,0-9.6,7.91,62.53,62.53,0,1,0,32.07-17.09Z",
    style: {
      stroke: "#fff",
      strokeWidth: "0.699999988079071px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.85,455.85A62.76,62.76,0,0,0,476.26,558,65,65,0,0,0,500,562.54a62.46,62.46,0,0,0,44.15-106.65A64.48,64.48,0,0,0,455.85,455.85Z",
    style: {
      stroke: "#fff",
      strokeWidth: "0.699999988079071px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.18,455.85A62.75,62.75,0,0,0,684.6,558a64.92,64.92,0,0,0,23.73,4.59,62.46,62.46,0,0,0,44.15-106.65A64.48,64.48,0,0,0,664.18,455.85Z",
    style: {
      stroke: "#fff",
      strokeWidth: "0.699999988079071px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.a7ec2bba.svg";
export { ForwardRef as ReactComponent };